import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import {
  fetchCaseListIds,
  setLastCaseViewed,
} from "shared/actions/casesActions";
import { CaseListPaginationParams } from "shared/reducers/casesReducer";

import ApplicationState from "store/ApplicationState";

import { BorderlessButton } from "./customInputs/buttons/Button";

type ViewerLinkProps = {
  caseId?: number;
  slideId?: number;
  className?: string;
  label?: string;
};

const ViewerLink = (props: ViewerLinkProps) => {
  const dispatch = useDispatch();
  const caseListPaginationParams: CaseListPaginationParams = useSelector(
    ({ cases }: ApplicationState) => cases.currentCaseSearch
  );
  const { caseId, slideId, label = "View →", className } = props;
  const to =
    slideId && caseId
      ? `/cases/${caseId}/slides/${slideId}`
      : caseId
      ? `/cases/${caseId}`
      : slideId
      ? `/slides/${slideId}`
      : ``;
  return (
    <Link
      onClick={() => {
        dispatch(setLastCaseViewed(caseId));
        dispatch(fetchCaseListIds(caseListPaginationParams));
      }}
      className={className}
      to={to}
    >
      <BorderlessButton>{label}</BorderlessButton>
    </Link>
  );
};
export default ViewerLink;
